import React, { useMemo } from "react";
import { TUserAccountData } from "types/user-account.type";
import { TAccountOfficeData } from "types/account-office.type";
import Styles from "./Avatar.module.scss";
import { Avatar, AvatarProps } from "@chakra-ui/react";

const DEFAULT_ASPECT_RATIO = 4 / 3;

interface IOfficeAvatarProps extends AvatarProps {
  account: TUserAccountData;
  office: TAccountOfficeData;
  aspectRatio?: number;
  heightInPx: number;
}

export const OfficeAvatar: React.FC<IOfficeAvatarProps> = ({
  account,
  office,
  aspectRatio = DEFAULT_ASPECT_RATIO,
  heightInPx,
  ...rest
}) => {
  const { name, logo, bg, height, width } = useMemo(() => {
    const name = office.name?.charAt(0) || "?";
    const logo = office.logoUrl || account.logoUrl || "";
    const bg = !!logo ? "transparent" : "blue.500";
    const height = heightInPx + "px";
    const width = heightInPx * aspectRatio + "px";

    return {
      name,
      logo,
      bg,
      height,
      width,
    };
  }, [office.name, office.logoUrl, account.logoUrl, heightInPx, aspectRatio]);

  return (
    <Avatar
      className={Styles["squareAvatar"]}
      rounded={"sm"}
      fontWeight={"500"}
      size={"md"}
      name={name}
      src={logo}
      height={height}
      width={width}
      bg={bg}
      {...rest}
    />
  );
};
